import { render, staticRenderFns } from "./report-query.vue?vue&type=template&id=15cf94c6&scoped=true"
import script from "./report-query.vue?vue&type=script&lang=js"
export * from "./report-query.vue?vue&type=script&lang=js"
import style0 from "./report-query.vue?vue&type=style&index=0&id=15cf94c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf94c6",
  null
  
)

export default component.exports